var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`circle circle_big ${
    this.color === 'purple' ? 'circle_purple' : ''
  }`},[_c('div',{staticClass:"data-content"},[_c('h1',[_vm._v(" "+_vm._s(_vm.amount.toLocaleString('sv-SE'))+" ")]),_c('p',{staticClass:"sub"},[_vm._v(_vm._s(_vm.$t(this.labelTranslationKey)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }